import { Injectable } from '@angular/core';
import { valorlatenteinterface  } from '../interface/ValorLatenteInterface';
import { operationinterface } from '../interface/OperationInterface';

@Injectable({
  providedIn: 'root'
})
export class PosicionesService {

  constructor() { }

  agregarPosicionesDesdeUltimoValorLiquidativo(
    posicionesUltimoValorLiquidativo: valorlatenteinterface[],
    posicionesModel: operationinterface[]
  ): operationinterface[] {
      posicionesModel = [];
      let c = 1;
      posicionesUltimoValorLiquidativo.forEach((valorLatente, index) => {
       // console.log("Valor Latente: ", valorLatente);
      const operacion: operationinterface = { estado: 'ACTIVO',
        idNectum: valorLatente.idnectum,
        isooper: valorLatente.isooper,
        compania: valorLatente.compania,
        fechaentrada: valorLatente.fechaentrada,
        precioentrada: valorLatente.precioentrada,
        cantidadacciones: valorLatente.cantidadacciones,
        numeroOperacion: index + 1,
        montoInicial: valorLatente.cantidadacciones * valorLatente.precioentrada,
        lastExecutionTimer: valorLatente.lastExecutionTimer || 0, // Ensure this is defined
        secType: valorLatente.secType,
        conid: valorLatente.conid,
        preciocierre: valorLatente.preciocierre,
        valorlatente: valorLatente.valorlatente,
        valorriesgo: valorLatente.valorriesgo,
        porcentajeValorLatente: (valorLatente.valorlatente / (valorLatente.precioentrada * valorLatente.cantidadacciones) * 100),
        fechaCotizacion: valorLatente.fechaintervalo,
        bajista: valorLatente.bajista,
        tipoOperacion: valorLatente.bajista ? 'SALIDA' : 'ENTRADA',
        idmodelo: valorLatente.idmodelo,
        order_ref: valorLatente.order_ref,
        hora: valorLatente.hora,
        horaCotizacion: valorLatente.horaCotizacion / 1000,
        stoploss: valorLatente.stoploss,
        profit: valorLatente.profit,
        acumuladocomision: 0,
        beneficioacumulado: 0,
        beneficioperdida: 0,
        capitalEmpleado: 0,
        capitalactual: 0,
        contador: 0,
        comision: 0,
        cotizacion: valorLatente.preciocierre,
        costeoperacion: 0,
        costereembolso: 0,
        efectivo: 0,
        fondosdisponibles: 0,
        margentotal: 0,
        podercompra: 0,
        precioentradareal: valorLatente.precioentrada,
        preciosalidareal: 0,
        reembolsoriesgo: 0,
        riesgooperacion: 0,
        riesgomaximo: 0,
        stoplossinicial: 0,
        valorlatentepor: (valorLatente.valorlatente / (valorLatente.precioentrada * valorLatente.cantidadacciones) * 100),
        valorliquidativo: 0,
        filasumatorio: 0,
        procesado: 0,
        fechaCompra: '',
        fechaOperacion: valorLatente.fechaentrada,
        idoperacion: 0,
        idcartera: 0,
        idoperacionasociada: 0,
        numeroreconfiguracion: 0,
        numoperaciones: c,
        orderId: 0,
        posicionsimultanea: 0,
        posicion: 0,
        nombreCompania: valorLatente.compania,
        fechaDate: '',
        tiporiesgo: '',
        broker: false, carteraid: 0, subcarteraid: 0, margenbroker: 0, porstoploss: valorLatente.porstoploss, porprofit: valorLatente.porprofit
      };

    c++;


      posicionesModel.push(operacion);

      // If you need to implement the commented out part for saving positions,
      // you would need to create a separate method to handle HTTP requests to your backend.
      // For example:
      // if (guardarPosiciones) {
      //   this.saveCompaniaCartera(valorLatente, operacion);
      // }
    });
   // console.log(posicionesModel);
    return posicionesModel;
  }


  // Uncomment and implement if needed
  // private saveCompaniaCartera(valorLatente: ValorLatente, operacion: Operacion): void {
  //   const companiaCartera = {
  //     idcartera: valorLatente.idcartera,
  //     procesado: true,
  //     idNectum: operacion.idNectum,
  //     cantidadteorica: operacion.cantidadacciones,
  //     cotizacion: operacion.precioentradareal,
  //     fecha: new Date()
  //   };
  //   // Make an HTTP request to save companiaCartera
  // }
}